import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function dm_c_02_testimonials() {
  const sections = document.querySelectorAll('section.c-02-testimonials');

  sections.forEach((section) => {
    const viewport = section.querySelector('.swiper');
    if (!viewport) return;

    // Swiper structure
    let wrapper = viewport.querySelector('.swiper-wrapper');
    let slides = Array.from(viewport.querySelectorAll('.quote'));

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';
      slides.forEach((el) => el.classList.add('swiper-slide'));
      viewport.replaceChildren(wrapper);
      slides.forEach((el) => wrapper.appendChild(el));
    } else {
      slides.forEach((el) => el.classList.add('swiper-slide'));
    }

    // Scope controls to this section
    const prevButtons = section.querySelectorAll('.swiper-btn.prev');
    const nextButtons = section.querySelectorAll('.swiper-btn.next');

    const swiper = new Swiper(viewport, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 16,
      autoHeight: false,
      speed: 600,

      navigation: {
        prevEl: prevButtons[0] || null,
        nextEl: nextButtons[0] || null
      },
    });

    prevButtons.forEach((btn) => {
      if (btn !== prevButtons[0]) btn.addEventListener('click', (e) => { e.preventDefault(); swiper.slidePrev(); });
    });
    nextButtons.forEach((btn) => {
      if (btn !== nextButtons[0]) btn.addEventListener('click', (e) => { e.preventDefault(); swiper.slideNext(); });
    });
  });
}

export { dm_c_02_testimonials };